import ko from "knockout";

export default function createRequiredObservable<T = any>(
    observable: KnockoutObservable<T>
): KnockoutObservable<boolean> {
    if (observable.rules) {
        const rules = observable.rules();
        for (let i = 0; i < rules.length; i++) {
            if (rules[i].rule === "required") {
                if (rules[i].condition && typeof rules[i].condition === "function") {
                    return ko.isObservable(rules[i].condition)
                        ? (rules[i].condition as KnockoutObservable<boolean>)
                        : ko.computed(rules[i].condition);
                } else {
                    return rules[i].params;
                }
            }
        }
    }
    return ko.observable(false);
}
